module.exports = __webpack_public_path__ + "img/larry-chevy.c5ad2c3f.jpg";